import React, { Component } from "react";
import ProductHeader from "../../ProductDetails/ProductHeader";
import { ReactComponent as Success } from "../assets/success.svg";
import wallet from "../assets/wallet.png";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { connect } from "react-redux";
import AssignmentIcon from "@material-ui/icons/Assignment";
import ActionButton from "../../ActionButton";
import { SwipeableDrawer } from "@material-ui/core";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import ReviewDrawerContent from "../../Branches/ReviewDrawerContent";
import { Redirect } from "react-router";
import { GetApp } from "@material-ui/icons";
import { clearLastOrder, saveDateStartEnd } from "../../../store/actions";
import { clearCart, updatePromotions } from "../../../store/actions/cart";
import ReactPixel from "@bettercart/react-facebook-pixel";
import ReactAckoo from "../../../ackoo";
import ReactGA from "react-ga4";
import SnapchatPixel from "react-snapchat-pixel";
import TiktokPixel from "../../../tiktok-pixel";
import TwitterPixel from "../../../TwitterPixel";
import { GTM } from "../../../App";
import GoogleAdsTracker from "../../../GoogleAdsTracker";
import Klaviyo from "../../../Klaviyo";
function waitForPixels(key, callback, tracking_id, facebookEnabled = false) {
  let pushEvent = false;
  if (window[key]) {
    if (key == "gtag") {
      setTimeout(function () {
        callback();
        sessionStorage.setItem("lastConversionID", tracking_id);
      }, 3000);
      return;
    } else {
      pushEvent = true;
    }
  } else if (key === "gtm" && GTM) {
    pushEvent = true;
  }
  if (pushEvent === true) {
    callback();
    sessionStorage.setItem("lastConversionID", tracking_id);
  } else {
    setTimeout(function () {
      waitForPixels(key, callback, tracking_id, facebookEnabled);
    }, 100);
  }
}

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
class index extends Component {
  analytics_purchase = (transaction_id = "", total_price, cart) => {
    const { settings, customer } = this.props;
    const totalCartLength = cart.length;

    const enableFacebook =
      this.props.settings.enable_fb_pixel &&
      Boolean(this.props.settings.fb_pixel);

    if (enableFacebook) {
      waitForPixels(
        "fbq",
        function () {
          ReactPixel.track(
            "Purchase",
            {
              currency: settings.currency_iso,
              num_items: totalCartLength,
              value: total_price,
              event_id: transaction_id,
            },
            { eventID: transaction_id }
          );
        },
        transaction_id
      );
    }

    if (
      this.props.settings.enable_snap_pixel &&
      this.props.settings.snap_pixel
    ) {
      waitForPixels(
        "snaptr",
        function () {
          SnapchatPixel.track("PURCHASE", {
            currency: settings.currency_iso,
            price: total_price,
            number_items: totalCartLength,
            item_ids: cart.map((item) => item.id),
            client_dedup_id: transaction_id,
            transaction_id: transaction_id,
            user_email: (customer?.email || "").toLowerCase().trim(),
            user_phone_number: (customer?.phone || "").replace("+", "").trim(),
            integration: "ordable",
          });
        },
        transaction_id
      );
    }

    if (
      this.props.settings.enable_google_analytics &&
      this.props.settings.google_analytics
    ) {
      waitForPixels(
        "gtag",
        function () {
          ReactGA.event({
            category: "purchase",
            action: `customer purchased ${total_price} ${settings.currency_iso} ${transaction_id}`,
            label: "customer_purchase",
            value: total_price,
          });
          ReactGA.gtag("event", "purchase", {
            transaction_id: transaction_id,
            value: total_price,
            currency: settings.currency_iso,
            items: cart.map((product) => ({
              id: product.id,
              name: product.name || "",
              item_id: product.id,
              item_name: product.name || "",
              price: product.total_price,
              category: product.category || "",
              quantity: product.quantity,
            })),
          });
        },
        transaction_id
      );
    }

    if (settings.enable_google_manager && settings.google_manager_id) {
      waitForPixels(
        "gtm",
        function () {
          GTM.track("purchase", {
            ecommerce: {
              purchase: {
                transaction_id: transaction_id,
                currency: settings.currency_iso,
                num_items: totalCartLength,
                value: total_price,
                items: cart.map((item) => {
                  return {
                    item_id: item.id,
                    item_name: item.name,
                    currency: settings.currency_iso,
                    value: item.total_price + item.quantityExcludedOptionsTotal,
                    price: item.total_price + item.quantityExcludedOptionsTotal,
                    quantity: item.quantity,
                  };
                }),
              },
            },
          });
        },
        transaction_id
      );
    }

    if (this.props.settings.enable_ackoo && this.props.settings.ackoo_api_key) {
      waitForPixels(
        "ackoo",
        function () {
          ReactAckoo.checkout({
            orderId: transaction_id,
            amount: total_price,
            currency: settings.currency_iso,
            items: cart.map((item) => {
              return {
                itemId: item.id.toString(),
                name: "",
                price: item.total_price + item.quantityExcludedOptionsTotal,
                quantity: item.quantity,
              };
            }),
          });
        },
        transaction_id
      );
    }
    if (
      settings.enable_google_ads_tracker &&
      settings.google_ads_conversion_id &&
      settings.google_ads_conversion_label
    ) {
      waitForPixels(
        "gtag",
        function () {
          const user_data = {
            email: customer?.email || "",
            phone_number: customer?.phone || "",
            address: {
              first_name: customer?.name | "",
            },
          };
          GoogleAdsTracker.track(
            "AW-" +
              settings.google_ads_conversion_id +
              "/" +
              settings.google_ads_conversion_label,
            transaction_id,
            total_price,
            user_data
          );
        },
        transaction_id
      );
    }

    if (
      this.props.settings.enable_tiktok_pixel &&
      this.props.settings.tiktok_pixel
    ) {
      waitForPixels("ttq", function () {
        TiktokPixel.track("CompletePayment", {
          content_type: "product",
          contents: cart.map((item) => {
            return {
              content_id: item.id.toString(),
              content_name: item.name,
              price: item.total_price + item.quantityExcludedOptionsTotal,
              quantity: item.quantity,
              currency: settings.currency_iso,
            };
          }),
          description: transaction_id,
          value: total_price,
          currency: settings.currency_iso,
          event_id: transaction_id,
        });
      });
    }
    if (settings.enable_twitter_pixel && settings.twitter_pixel) {
      waitForPixels("twq", function () {
        if (settings.twitter_events["Purchase"]) {
          TwitterPixel.track(settings.twitter_events["Purchase"], {
            value: total_price,
            currency: settings.currency_iso,
            contents: cart.map((item) => {
              return {
                content_type: "product",
                content_id: item.id,
                content_name: item.name,
                content_price:
                  item.total_price + item.quantityExcludedOptionsTotal,
                num_items: item.quantity,
              };
            }),

            conversion_id: transaction_id,
            email_address: customer?.email || "",
            phone_number: customer?.phone || "",
          });
        }
      });
    }

    if (Klaviyo.isInitialized()) {
      waitForPixels("klaviyo", function () {
        Klaviyo.track(
          "Placed Order",
          {
            email: customer?.email || "",
            phone_number: customer?.phone || "",
            first_name: customer?.name || "",
          },
          {
            $event_id: transaction_id,
            Value: total_price,
            $value: total_price,
            Items: cart.map((item) => {
              return {
                ProductID: item.id,
                SKU: item.id,
                ProductName: item.name,
                ItemPrice: item.total_price + item.quantityExcludedOptionsTotal,
                Quantity: item.quantity,
              };
            }),
          }
        );
      });
    }
  };
  componentDidMount() {
    if (
      this.props.history.location.state ||
      (this.props.match.params.Tid && this.props.lastOrder)
    ) {
      const tracking_id = this.props.history.location.state
        ? this.props.history.location.state.tracking_id
            .split("-")
            .slice(0, 2)
            .join("-")
        : this.props.match.params.Tid.split("-").slice(0, 2).join("-");

      const total_price = this.props.history.location.state
        ? this.props.history.location.state.total_price_with_discounts
        : this.props.lastOrder.total_price_with_discounts;
      const cart = this.props.history.location.state
        ? this.props.history.location.state.cart
        : this.props.lastOrder.cart;

      let lastConversionID = sessionStorage.getItem("lastConversionID");

      if (cart && lastConversionID !== tracking_id) {
        sessionStorage.setItem("lastConversionID", tracking_id);
        this.analytics_purchase(tracking_id, total_price, cart);
      }

      this.props.clearCart();
      this.props.clearSpecialRemarks();
      this.props.clearSpecialRemarksFiles();
      this.props.saveDateStartEnd();
      if (this.props.smart_promos?.length) {
        this.props.updatePromotions();
      }

      const isWalletPromise =
        tracking_id ===
          this.props.lastOrder?.tracking_id.split("-").slice(0, 2).join("-") &&
        this.props.lastOrder?.wallet_promise;

      if (this.props.settings.enable_tracking && !isWalletPromise)
        this.props.history.replace(
          `/track/order/${
            this.props.history.location.state
              ? this.props.history.location.state.tracking_id
                  .split("-")
                  .slice(0, 2)
                  .join("-")
              : this.props.match.params.Tid.split("-").slice(0, 2).join("-")
          }`
        );
    }
  }
  state = {
    open: false,
    drawerOpen: false,
  };
  toggleDrawer = (state) => {
    this.setState({ drawerOpen: state });
  };

  render() {
    const { language, settings } = this.props;

    if (!this.props.history.location.state && !this.props.match.params.Tid)
      return <Redirect to="/" />;

    if (this.props.match.params.Tid && !this.props.lastOrder) {
      return <Redirect to="/" />;
    }

    const tracking_id = this.props.history.location.state
      ? this.props.history.location.state.tracking_id
          .split("-")
          .slice(0, 2)
          .join("-")
      : this.props.match.params.Tid.split("-").slice(0, 2).join("-");

    try {
      if (this.props.match.params.Tid)
        if (
          tracking_id !=
          this.props.lastOrder.tracking_id.split("-").slice(0, 2).join("-")
        )
          return <Redirect to="/" />;
    } catch (err) {
      return <Redirect to="/" />;
    }
    const isWalletPromise =
      tracking_id ===
        this.props.lastOrder?.tracking_id.split("-").slice(0, 2).join("-") &&
      this.props.lastOrder?.wallet_promise;

    if (this.props.settings.enable_tracking && !isWalletPromise) return <></>;

    const has_downloadables = this.props.history.location.state
      ? this.props.history.location.state.has_downloadables
      : this.props.lastOrder.has_downloadables;

    const copyToClipboard = () => {
      const textField = document.createElement("textarea");
      textField.innerText = tracking_id;
      document.body.appendChild(textField);
      textField.select();
      document.execCommand("copy");
      textField.remove();
    };
    const handleClose = (event, reason) => {
      if (reason === "clickaway") {
        return;
      }

      this.setState({ open: false });
    };

    const total_price = this.props.history.location.state
      ? this.props.history.location.state.total_price_with_discounts
      : this.props.lastOrder.total_price_with_discounts;

    return (
      <div style={{ backgroundColor: "white", minHeight: window.innerHeight }}>
        <ProductHeader
          onBack={() => {
            this.props.clearLastOrder();
            this.props.history.replace("/");
          }}
        />
        {this.props.settings.enable_feedback && (
          <SwipeableDrawer
            anchor="bottom"
            open={this.state.drawerOpen}
            onClose={() => this.toggleDrawer(false)}
            PaperProps={{
              style: { minHeight: 100, height: "auto" },
              className: "text-center",
            }}
            onBackdropClick={() => this.toggleDrawer(false)}
          >
            <ReviewDrawerContent
              closeDrawer={() => this.toggleDrawer(false)}
              trackingCode={tracking_id}
            />
          </SwipeableDrawer>
        )}
        <Snackbar
          open={this.state.open}
          autoHideDuration={3000}
          onClose={handleClose}
          classes={{ anchorOriginBottomCenter: "snackbar-bottom-70" }}
        >
          <Alert onClose={handleClose} severity="success">
            {language == "english"
              ? "Code copied successfully!"
              : "تم نسخ رقم التتبع"}
          </Alert>
        </Snackbar>
        <div className="free-space-190-white"></div>
        <Success width="100" height="100" />
        {isWalletPromise ? (
          <>
            <p
              className="mt-4"
              style={{ fontSize: "1rem" }}
              dir={language == "english" ? "ltr" : "rtl"}
            >
              {language == "english"
                ? "Your wallet was recharged successfully!"
                : "لفد تم تعبئة المحفضة بنجاح!"}
            </p>
            <p
              className="mt-4"
              style={{ fontSize: "1rem" }}
              dir={language == "english" ? "ltr" : "rtl"}
            >
              {language == "english" ? "Invoice ID: " : "رقم تتبع: "}{" "}
              <span style={{ fontWeight: 600 }}>{tracking_id}</span>
            </p>
          </>
        ) : (
          <p
            className="mt-4"
            style={{ fontSize: "1rem" }}
            dir={language == "english" ? "ltr" : "rtl"}
          >
            {language == "english"
              ? "Your order has been placed successfully!"
              : "لقد تم وضع طلبك بنجاح!"}
          </p>
        )}
        {!isWalletPromise && (
          <p
            className="mt-4"
            style={{ fontSize: "1rem" }}
            dir={language == "english" ? "ltr" : "rtl"}
          >
            {language == "english"
              ? "Your order tracking code is:"
              : "رقم تتبع طلبك هو:"}{" "}
            <span style={{ fontWeight: 600 }}>{tracking_id}</span>
          </p>
        )}
        {!isWalletPromise && (
          <Button
            variant="contained"
            className="mt-4"
            color="primary"
            disableElevation
            onClick={() => {
              copyToClipboard();
              this.setState({ open: true });
            }}
            endIcon={language == "english" ? <AssignmentIcon /> : null}
            startIcon={language == "arabic" ? <AssignmentIcon /> : null}
          >
            <span>
              {language == "english" ? "Copy Code" : "نسخ رقم التتبع"}
            </span>
          </Button>
        )}
        {!isWalletPromise && has_downloadables ? (
          <div style={{ display: "block", marginTop: 10 }}>
            <Button
              variant="contained"
              className="mt-4 mx-auto"
              color="primary"
              disableElevation
              onClick={() => {
                this.props.history.push(`/download/${tracking_id}`);
              }}
              endIcon={language == "english" ? <GetApp /> : null}
              startIcon={language == "arabic" ? <GetApp /> : null}
            >
              <span>{language == "english" ? "Download" : "تحميل"} </span>
            </Button>
          </div>
        ) : null}
        {!isWalletPromise && this.props.settings.enable_feedback && (
          <Button
            color="primary"
            className="mt-5 mx-auto"
            style={{ display: "block" }}
            onClick={() => this.toggleDrawer(true)}
            endIcon={language == "english" && <ThumbUpIcon />}
            startIcon={language == "arabic" && <ThumbUpIcon />}
          >
            <span>
              {language == "english" ? "Rate your experience" : "قيم تجربتك"}
            </span>
          </Button>
        )}
        <div className="free-space-80-white"></div>
        <ActionButton
          action={
            language == "english"
              ? "Back to shopping"
              : "العودة الى القائمة الرئيسية"
          }
          onClick={() => {
            this.props.clearLastOrder();
            this.props.history.replace("/");
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    settings: state.store.store.settings,
    cart: state.cart,
    lastOrder: state.PastOrders.lastOrder,
    customer: state.customers.customerContact,
    smart_promos: state.store.store.smart_promos,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    clearLastOrder: () => dispatch(clearLastOrder()),
    clearCart: () => dispatch(clearCart()),
    saveDateStartEnd: (obj) => dispatch(saveDateStartEnd(obj)),
    clearSpecialRemarks: () =>
      dispatch({ type: "SET_SPECIAL_REMARKS", payload: "" }),
    clearSpecialRemarksFiles: () =>
      dispatch({
        type: "SET_SPECIAL_REMARKS_FILES",
        payload: { url: null, name: null },
      }),

    updatePromotions: () => dispatch(updatePromotions()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(index);
